// extracted by mini-css-extract-plugin
module.exports = {"Btn":"style_Btn__2SzNk","BtnO":"style_BtnO__1AOVP"};